/**
 * GD Motion Fallback
 * Activates IntersectionObserver-based reveal animations for
 * browsers that don't support CSS Scroll-Driven Animations (Firefox).
 * In supporting browsers (Chrome/Edge/Safari 26+) this script does nothing.
 */
(function() {
  'use strict';

  // Only run fallback if CSS Scroll-Driven Animations aren't supported
  const supportsScrollTimeline =
    CSS.supports('(animation-timeline: view()) and (animation-range: entry)');

  if (supportsScrollTimeline) return;

  // Add initial hidden state to all reveal elements
  const revealSelectors = [
    '.gd-reveal',
    '.gd-reveal--fade',
    '.gd-reveal--left',
    '.gd-reveal--right',
    '.gd-reveal--scale',
    '.gd-stagger'
  ];

  const allReveal = document.querySelectorAll(revealSelectors.join(','));

  allReveal.forEach(el => {
    el.classList.add('gd-fallback-hidden');
  });

  // IntersectionObserver to trigger reveals
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;

        if (el.classList.contains('gd-stagger')) {
          // Stagger children
          const children = el.children;
          Array.from(children).forEach((child, i) => {
            setTimeout(() => {
              child.classList.add('is-visible');
              child.style.opacity = '1';
              child.style.translate = '0 0';
            }, i * 80);
          });
        }

        el.classList.remove('gd-fallback-hidden');
        el.classList.add('is-visible');
        observer.unobserve(el);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px'
  });

  allReveal.forEach(el => observer.observe(el));

  // Shrinking header fallback
  const supportsScrollAnim =
    CSS.supports('(animation-timeline: scroll()) and (animation-range: 0% 100%)');

  if (!supportsScrollAnim) {
    const header = document.getElementById('gd-header');
    if (header) {
      const initialHeight = 68;
      const finalHeight = 52;
      const scrollDistance = 120;

      window.addEventListener('scroll', () => {
        const scrollY = Math.min(window.scrollY, scrollDistance);
        const progress = scrollY / scrollDistance;
        const newHeight = initialHeight - (initialHeight - finalHeight) * progress;
        const newBg = `rgba(255,255,255,${0.72 + progress * 0.2})`;
        header.querySelector('.gd-header__inner').style.height = `${newHeight}px`;
        header.style.background = newBg;
      }, { passive: true });
    }
  }

  // Carousel snap highlight fallback (for Firefox)
  if (!CSS.supports('container-type', 'scroll-state')) {
    const carousel = document.getElementById('ing-carousel');
    if (carousel) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const visual = entry.target.querySelector('.gd-ing__slide-visual');
          if (visual) {
            if (entry.isIntersecting) {
              visual.style.boxShadow = '0 24px 64px rgba(11,143,172,0.18)';
              visual.style.borderColor = 'rgba(11,143,172,0.25)';
            } else {
              visual.style.boxShadow = '';
              visual.style.borderColor = '';
            }
          }
        });
      }, {
        root: carousel,
        rootMargin: '0px -49%',
        threshold: 0
      });

      carousel.querySelectorAll('.gd-ing__slide').forEach(slide => {
        observer.observe(slide);
      });
    }
  }
})();
